import {
    combineReducers,
} from 'redux';

import fetchTestsReducerMap, {
    fetchTestsAction,
} from './actions/fetchTests';
import * as splitTestActions from './appstate/actions';
import appStateReducerMap from './appstate/reducer';
import * as splitTestSelectors from './appstate/selectors';
import NAMESPACE from './types';
import {
    fireSplitTestEvent,
    initializeVisitorId,
    SPLIT_TEST_COOKIE_NAME,
} from './utils';

const reducer = combineReducers({
    ...appStateReducerMap,
    ...fetchTestsReducerMap,
});

export {
    SPLIT_TEST_COOKIE_NAME,
    fetchTestsAction,
    fireSplitTestEvent,
    initializeVisitorId,
    splitTestActions,
    splitTestSelectors,
};

export default {
    [NAMESPACE]: reducer,
};
